<template>
  <div>
    <!-- Product Grid Layout -->
    <div class="grid grid-cols-1 gap-6 sm:gap-8 md:grid-cols-2 lg:gap-10">
      <div v-for="product in products" :key="product.id" class="relative bg-white rounded-2xl shadow-md p-6">
        <!-- Product Header with Title and Image -->
        <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 sm:gap-0 mb-4 sm:mb-6">
          <h3
            class="text-lg sm:text-xl font-semibold text-gray-800 sm:flex-1 sm:mr-4 leading-tight sm:leading-7 order-2 sm:order-1"
          >
            {{ product.title }}
          </h3>
          <div v-if="product.imageUrl" class="shrink-0 self-center sm:self-start order-1 sm:order-2">
            <div
              class="relative h-20 w-20 sm:h-24 sm:w-24 overflow-hidden rounded-lg bg-gray-100 border border-gray-200"
            >
              <img class="h-full w-full object-cover" :src="product.imageUrl" :alt="product.title || 'Product image'" />
            </div>
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
          <div class="space-y-2">
            <StackedField v-if="product.itemType" label="Catégorie" :value="$t(product.itemType)" />
            <StackedField label="Vendeur" :value="product.vendor" />
            <StackedField v-if="product.model" label="Modèle" :value="product.model" />
            <StackedField label="Prix" :value="formatPrice(product.price)" />
          </div>
          <div class="space-y-2">
            <StackedField v-if="product.referenceId" label="N° série" :value="product.referenceId" />
            <StackedField label="Achat" :value="product.purchaseDate" />
            <StackedField v-if="product.insuranceStartDate" label="Ajout" :value="product.insuranceStartDate" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// UI Components and Utilities
import { StackedField, formatPrice } from "@estaly/ui";

export default {
  name: "InsuredProductsInformations",

  components: {
    StackedField,
  },

  props: {
    products: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  methods: {
    formatPrice,
  },
};
</script>
